module.exports = __webpack_public_path__ + "img/tzh.6ce9cb00.jpg";